import { PartialBlock } from "@blocknote/core";
import { fileTypes, FileTypeSettings } from "src/js/stores/editor/fileTypes";
import { proxy } from "valtio/vanilla";

export type EditorStore = {
  showWorkbench: boolean;
  siteId?: string;
  siteTitle: string;
  showPreview: boolean;
  localFileContents: PartialBlock[];
  savedFileContents: PartialBlock[];
  isSaved: boolean;
  fileType: FileTypeSettings;
  fileName: string;
};

export const getInitialEditorStore = () =>
  ({
    showWorkbench: true,
    siteId: undefined,
    siteTitle: "",
    showPreview: false,
    localFileContents: [],
    savedFileContents: [],
    isSaved: true,
    fileType: fileTypes.planning_summary,
    fileName: fileTypes.planning_summary.label,
  } as EditorStore);

export const editorStore = proxy<EditorStore>(getInitialEditorStore());
